import { kebabToCamelConverter } from './kebabToCamel.js';
export const kebabToPascalConverter = (string) => kebabToCamelConverter(string.replace(/^\w/, (s) => s.toUpperCase()));
//# sourceMappingURL=kebabToPascal.js.map